// extracted by mini-css-extract-plugin
export default {"content":"cZwftBsCKR4sEZhYj0u7"};